import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import BrandLogo from "../../components/logo/BrandLogo";
import GlobalAddButton from "./GlobalAddButton";
import GlobalSearch from "./GlobalSearch";
import Notifications from "./Notifications";
import UserAvatarIcon from "./UserAvatarIcon";
import classnames from "classnames";
import { logoutAction } from "../store";
import { useHistory, Link } from "react-router-dom";
import { State } from "../../core/store/interfaces";
import { RouteKeys } from "../../containers/routes/route-keys";
import userDefaultImage from "../../assets/images/user-noimage.png";
import AddLeadForm from "../../containers/leads/AddLeadForm";
import AddCustomer from "../../containers/customer/AddCustomer";
import { CreateEventPopup } from "../../containers/leads/components/activities/create-event-popup";
import { useAppSettings } from "../hooks/useAppSettings";
import api from "../../api";
import { combineDateAndTime } from "../../utils/CombineDateAndTime";
import { DateFormats, getMinutes, useOutsideClick } from "../../core";
import moment from "moment";
import AddUser from "../../containers/company/AddUser";

const Header: React.FunctionComponent<{
  onMenuOpen?: () => void;
  showOpenHideMenu?: boolean;
  headerMenuRef?: React.MutableRefObject<any>;
}> = (props) => {
  const authState = useSelector((state: State) => state.authUser);
  const appSettings = useAppSettings(api.settings);

  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setOpen(false);
  });


  const [addModal, setAddModal] = useState<{
    isOpen?: boolean;
    type?: string;
  }>({});

  React.useEffect(() => {
    // if (navigator.appVersion.indexOf("Win") !== -1) {
    //   const script = document.createElement("script");
    //   script.src = "http://localhost:80/cid/integrate";
    //   script.async = true;
    //   document.body.appendChild(script);
    // }
  }, []);

  React.useEffect(() => {
    // loadUserBack();
  }, []);

  const loadUserBack = async () => {
    const data = await api.settings.getAppSettings();
    if (data?.userback?.userbackToken) {
      const scriptUserBack = document.createElement("script");
      scriptUserBack.innerHTML = ` window.Userback = window.Userback || {};
      Userback.access_token = '${data?.userback?.userbackToken}';
      (function (d) {
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://static.userback.io/widget/v1.js';
        (d.head || d.body).appendChild(s);
      })(document);`;

      document.head.appendChild(scriptUserBack);
    }
  };

  const minimumDurationInMinutes = getMinutes(
    appSettings?.data?.activity?.activityMinimumDuration || {
      value: 15,
      unit: "Minutes",
    }
  );

  const startDateTime = combineDateAndTime(
    moment().startOf("day").toDate(),
    appSettings?.data?.application?.appointmentTime?.start || "9:30 AM"
  );

  return (
    <header className="border-bottom py-2" ref={ref}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-5 col-auto d-flex align-items-center">
            <div className="d-lg-none d-inline-flex mr-3">
              <i className="icon-menu"></i>
            </div>
            <a href={RouteKeys.Home}>
              <BrandLogo className="mr-1 d-sm-inline-block d-none" />
            </a>
            {/* <a href={RouteKeys.Home}>
              <AlghanimLogo className="d-sm-inline-block d-none" />
            </a> */}
            {props.showOpenHideMenu && (
              <div
                ref={props?.headerMenuRef}
                className="d-none d-sm-inline-block ml-3  cursor-pointer font-sm"
                onClick={props.onMenuOpen}
              >
                <i className="icon-menu"></i>
              </div>
            )}
          </div>

          {/* <div className="col-lg-5 col pr-md-3 pr-2 d-flex header-middle justify-content-md-start justify-content-end position-static">
            <GlobalSearch className="d-flex mr-md-2 mr-4 flex-md-fill" />
          </div> */}

          <div className="col-lg col-auto d-flex justify-content-end align-items-center">
          {history.location.pathname !== RouteKeys.Home && (
              <button className="mr-3 bg-transparent border-0 text-gray-500">
                <i
                  className="icon-search"
                  style={{ fontSize: "20px" }}
                  onClick={() => history.push(`${RouteKeys.GlobalSearch}`)}
                ></i>
              </button>
            )}


            <GlobalAddButton
              className="mr-3 rounded-circle d-inline-flex align-items-center justify-content-center cursor-pointer font-lg text-gray-500"
              setAddModal={(type: string) =>
                setAddModal({ isOpen: true, type })
              }
            />
            <Notifications className="border d-inline-flex align-items-center justify-content-center rounded-circle  mr-4 cursor-pointer" />
            <div className="pl-2" onClick={() => setOpen(!isOpen)}>
              <div className="dropdown">
                <UserAvatarIcon
                  id={authState?.profile?._id}
                  imageUrl={authState?.profile?.avatar?.location}
                  image={authState?.profile?.avatar}
                />
                {/* add class "in" to "dropdown-menu" */}
                <ul
                  className={classnames({
                    "dropdown-menu dropdown-menu-right dropdown-shadow font-sm border-0": true,
                    in: isOpen,
                  })}
                >
                  <i className="d-block text-center border-bottom">
                    <Link to="/profile">
                      <UserAvatarIcon
                        id={authState?.profile?._id}
                        imageUrl={authState?.profile?.avatar?.location}
                        image={authState?.profile?.avatar}
                      />
                      <div className="font-normal">
                        <h6 className="mb-0 font-weight-semibold mb-3 mt-3">
                          {authState?.profile?.name}
                        </h6>
                        
                      </div>
                    </Link>
                  </i>
                  <i>
                    <button
                      className="dropdown-item px-3 py-2 font-weight-semibold text-center"
                      onClick={() => {
                        dispatch(logoutAction());
                        history.push(RouteKeys.Login);
                      }}
                    >
                      Logout
                    </button>
                  </i>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {addModal.isOpen && addModal.type === "Lead" && (
        <AddLeadForm onClose={() => setAddModal({})} />
      )}
      {addModal.isOpen && addModal.type === "Customer" && (
         <AddUser
          onClose={() => setAddModal({})}
          customerCreated={()=>setAddModal({})}
          isNormalCustomer={true}
       />
      )}
      {/* {addModal.isOpen && addModal.type === "Customer" && (
        <AddCustomer onClose={() => setAddModal({})} />
      )} */}
      {addModal.isOpen && addModal.type === "Activity" && (
        <CreateEventPopup
          onClose={() => {
            setAddModal({});
          }}
          onSubmit={() => {
            setAddModal({});
          }}
          initialData={{
            timePeriod: {
              startDate: new Date(),
              startTime:
                appSettings?.data?.application?.appointmentTime?.start ||
                "9:00 AM",
              endTime:
                moment(startDateTime)
                  .add(minimumDurationInMinutes, "minute")
                  .format(DateFormats.TimeOnlyFormat) || "9:30 AM",
            },
            busyEvent: true,
          }}
          resourceType={"staff"}
          changeLead={true}
          loadCurrentTime
        ></CreateEventPopup>
      )}
    </header>
  );
};

export default Header;
